import { type UseQueryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { ItemStatusApi } from '@/lib/api/common/itemStatus';
import type { ItemStatus } from '@/lib/api/types/itemStatus';
import { commonQueryKeys } from '@/lib/query-keys/common';
import { associateById } from '@/lib/utils/common/associateById';

export const useGetItemStatusByIdQuery = ({
  id,
  options = {},
}: {
  id: number;
  options?: Partial<UseQueryOptions<ItemStatus, Error, ItemStatus>>;
}) => {
  return useQuery({
    queryKey: commonQueryKeys.itemStatuses.detail(id),
    queryFn: () => ItemStatusApi.getItemStatusById(id),
    ...options,
  });
};

export const getItemStatusesQueryOptions = () => {
  return {
    queryKey: commonQueryKeys.itemStatuses.all(),
    queryFn: () => ItemStatusApi.getItemStatuses(),
  };
};

export const useSuspenseGetItemStatusesQuery = () => {
  return useSuspenseQuery<ItemStatus[]>({
    ...getItemStatusesQueryOptions(),
  });
};

export const useGetItemStatusesQuery = (options: Partial<UseQueryOptions<ItemStatus[]>> = {}) => {
  return useQuery({
    ...getItemStatusesQueryOptions(),
    ...options,
  });
};

export const useGetItemStatusesByIdQuery = (
  options: Partial<UseQueryOptions<ItemStatus[]>> = {},
) => {
  return useQuery({
    ...getItemStatusesQueryOptions(),
    ...options,
    select: associateById,
  });
};
